import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { PricingApiConfig } from './api-configs/pricing-api.api-config';
export const PricingApiClient = createApiClient(PricingApiConfig);
//# sourceMappingURL=pricing-api.api-client.js.map